const state = {
  medalListAll: [],
  medalTabListAll: []
};

// mutations
const mutations = {
  MEDALLISTALL(state, val) {
    state.medalListAll = val;
  },
  MEDALTABLISTALL(state, val) {
    state.medalTabListAll = val;
  }
};

// actions
const actions = {};

export default {
  state,
  actions,
  mutations
};
